import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Eyebrow, Reveal } from "../landing/shared";

const TYPES = [
    {
        title: "Companies",
        copy: "For organizations seeking qualified international employees.",
    },
    {
        title: "Contractors & Projects",
        copy: "For businesses requiring workforce support for projects or expansion.",
    },
    {
        title: "International Employers",
        copy: "For organizations recruiting talent across borders.",
    },
];

export const EmployerTypes = () => (
    <section data-testid="employer-types-section" className="bg-ivory py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
            <Reveal className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
                <div>
                    <Eyebrow>Who We Work With</Eyebrow>
                    <h2 className="mt-5 max-w-2xl font-serif text-3xl font-medium tracking-tight text-ink sm:text-4xl lg:text-5xl">
                        Built Around Your Workforce Needs
                    </h2>
                </div>
                <p className="max-w-sm text-sm leading-relaxed text-ink/60">
                    Every engagement is shaped around how your organization actually hires — its roles,
                    timelines and standards.
                </p>
            </Reveal>

            <Reveal className="mt-14">
                <div className="grid divide-y divide-ink/10 border border-ink/10 md:grid-cols-3 md:divide-x md:divide-y-0">
                    {TYPES.map((type, i) => (
                        <div
                            key={type.title}
                            data-testid={`type-${type.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                            className="group relative p-8 transition-colors duration-300 hover:bg-sand lg:p-12"
                        >
                            <div className="flex items-start justify-between">
                                <span className="font-serif text-5xl font-medium text-forest/25 transition-colors duration-300 group-hover:text-forest/60">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <ArrowUpRight
                                    size={18}
                                    strokeWidth={1.5}
                                    className="text-forest opacity-0 transition-all duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:opacity-100"
                                />
                            </div>
                            <span
                                className="mt-10 block h-px w-10 bg-champagne/70 transition-all duration-500 group-hover:w-16"
                                aria-hidden="true"
                            />
                            <h3 className="mt-5 font-serif text-2xl font-medium tracking-tight text-ink lg:text-[1.7rem]">
                                {type.title}
                            </h3>
                            <p className="mt-3 max-w-xs text-sm leading-relaxed text-ink/60">{type.copy}</p>
                        </div>
                    ))}
                </div>
            </Reveal>

            <Reveal delay={0.1} className="mt-10">
                <p className="text-sm leading-relaxed text-ink/55">
                    Every engagement begins with a conversation about your requirements.{" "}
                    <a
                        href="#employer-form"
                        data-testid="types-start-request-link"
                        className="inline-flex items-center gap-1.5 font-medium text-forest transition-colors hover:text-champagne"
                    >
                        Tell us what you need
                        <ArrowRight size={14} strokeWidth={1.5} />
                    </a>
                </p>
            </Reveal>
        </div>
    </section>
);
